module.exports = __webpack_public_path__ + "img/schedule_banner.64ba494d.png";